import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select-arrow",
  "use": "icon-select-arrow-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.4949 6.50483C15.2216 6.23146 14.7783 6.23146 14.505 6.50483L9.99995 11.0099L5.49493 6.50483C5.22156 6.23146 4.77834 6.23146 4.50498 6.50483C4.23161 6.7782 4.23161 7.22141 4.50498 7.49478L9.50498 12.4948C9.77834 12.7681 10.2216 12.7681 10.4949 12.4948L15.4949 7.49478C15.7683 7.22141 15.7683 6.7782 15.4949 6.50483Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol